import { createFileRoute } from "@tanstack/react-router";
import { ProceduresLibrary } from "@/features/experiments/workspace-pages";
import { uploadSearch } from "@/lib/upload-route";

export const Route = createFileRoute("/procedures/")({
  validateSearch: uploadSearch,
  component: ProceduresLibrary,
});
